var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.27 0 78.54 0 119 0 C119 3.63 119 7.26 119 11 C101.18 11 83.36 11 65 11 C65 15.62 65 20.24 65 25 C70.61 25 76.22 25 82 25 C82 28.3 82 31.6 82 35 C67.48 35 52.96 35 38 35 C38 31.7 38 28.4 38 25 C43.61 25 49.22 25 55 25 C55 20.38 55 15.76 55 11 C36.85 11 18.7 11 0 11 C0 7.37 0 3.74 0 0 Z ",
    fill: "#000000",
    transform: "translate(25,106)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C31.34 5.94 30.68 11.88 30 18 C17.46 18 4.92 18 -8 18 C-6 12 -6 12 0 0 Z ",
    fill: "#000000",
    transform: "translate(33,83)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C33.155 2.413125 34.31 4.82625 35.5 7.3125 C36.04817383 8.44619019 36.04817383 8.44619019 36.60742188 9.6027832 C38.01021234 12.57178444 39 14.67854187 39 18 C26.79 18 14.58 18 2 18 C0 6 0 6 0 0 Z ",
    fill: "#000000",
    transform: "translate(105,83)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30.66 5.94 31.32 11.88 32 18 C20.78 18 9.56 18 -2 18 C-1 5 -1 5 0 0 Z ",
    fill: "#000000",
    transform: "translate(70,83)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.58 0 17.16 0 26 0 C32 12.625 32 12.625 32 16 C22.1 16 12.2 16 2 16 C1.34 10.72 0.68 5.44 0 0 Z ",
    fill: "#000000",
    transform: "translate(102,62)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.58 0 17.16 0 26 0 C25.34 5.28 24.68 10.56 24 16 C14.1 16 4.2 16 -6 16 C-5 11 -5 11 0 0 Z ",
    fill: "#000000",
    transform: "translate(42,62)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.92 0 15.84 0 24 0 C24.66 5.28 25.32 10.56 26 16 C16.76 16 7.52 16 -2 16 C-1 3 -1 3 0 0 Z ",
    fill: "#000000",
    transform: "translate(73,62)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.38031589 1.18767855 3.93216817 1.89825225 6 5 C6.82989594 9.66488876 6.61181179 13.03294265 4.0625 17.0625 C-0.05858493 19.669717 -3.24941677 20.03945854 -8 19 C-11.20879247 16.96994762 -12.62927537 15.57700553 -13.5078125 11.83984375 C-13.85679663 7.29546348 -13.43155073 5.51575575 -10.4375 1.9375 C-6.49924653 -0.28224286 -4.4487046 -0.57668393 0 0 Z ",
    fill: "#000000",
    transform: "translate(30,20)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C24 10.625 24 10.625 24 14 C16.41 14 8.82 14 1 14 C0 8 0 8 0 0 Z ",
    fill: "#000000",
    transform: "translate(100,42)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C18.125 12.875 18.125 12.875 17 14 C15.29227642 14.08713831 13.58101351 14.10700007 11.87109375 14.09765625 C10.31938477 14.09282227 10.31938477 14.09282227 8.73632812 14.08789062 C7.64771484 14.07951172 6.55910156 14.07113281 5.4375 14.0625 C3.7987793 14.05573242 3.7987793 14.05573242 2.12695312 14.04882812 C-0.58205432 14.0369984 -3.2910338 14.01906231 -6 14 C-4.02 9.38 -2.04 4.76 0 0 Z ",
    fill: "#000000",
    transform: "translate(51,42)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C21 9.5 21 9.5 21 14 C13.74 14 6.48 14 -1 14 C-0.67 9.38 -0.34 4.76 0 0 Z ",
    fill: "#000000",
    transform: "translate(75,42)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 1.65 9 3.3 9 5 C6.03 5 3.06 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#000000",
    transform: "translate(6,27)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.88437779 1.29299694 4.87219421 2.65941363 7 5 C6.34 6.32 5.68 7.64 5 9 C2.11562221 7.70700306 0.12780579 6.34058637 -2 4 C-1.34 2.68 -0.68 1.36 0 0 Z ",
    fill: "#000000",
    transform: "translate(13,14)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.35964273 0.40683495 3.85934088 0.89814339 5.8125 2.3125 C7 4 7 4 6.6875 6.1875 C6.460625 6.785625 6.23375 7.38375 6 8 C3.64035727 7.59316505 2.14065912 7.10185661 0.1875 5.6875 C-1 4 -1 4 -0.6875 1.8125 C-0.460625 1.214375 -0.23375 0.61625 0 0 Z ",
    fill: "#000000",
    transform: "translate(35,37)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8 1.65 8 3.3 8 5 C5.36 5 2.72 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#000000",
    transform: "translate(39,27)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.66 1.98 1.32 3 2 C1.60667426 5.36720387 0.0210714 6.9859524 -3 9 C-3.66 8.34 -4.32 7.68 -5 7 C-4.875 5.0625 -4.875 5.0625 -4 3 C-1.9375 1.25 -1.9375 1.25 0 0 Z ",
    fill: "#000000",
    transform: "translate(39,14)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.66 2.64 1.32 4 2 C2.35 3.98 0.7 5.96 -1 8 C-2.32 7.34 -3.64 6.68 -5 6 C-3.35 4.02 -1.7 2.04 0 0 Z ",
    fill: "#000000",
    transform: "translate(16,37)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 2.97 4 5.94 4 9 C2.68 9 1.36 9 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#000000",
    transform: "translate(25,9)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 2.64 4 5.28 4 8 C2.68 8 1.36 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#000000",
    transform: "translate(25,42)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolar);
export default __webpack_public_path__ + "static/media/solar.2a9bc66e3a122b2a16bae814f2588393.svg";
export { ForwardRef as ReactComponent };